import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (!environment.enableConsoleLog) {
  console.log = function () { };
  console.info = function () { };
  console.warn = function () { };
  // Optionally, you might want to keep console.error enabled to catch critical errors
  // console.error = function () { };
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
